import Collapse from "@mui/material/Collapse";
import MuiList from "@mui/material/List";
import { useState } from "react";

import ListItem from "./ListItem";

export default function List(props) {
	const padding = props.padding || 0;

	const [openedElement, setIsOpenedElement] = useState(null);

	const isExpandedList = (element) => {
		return element.relatedItems.length > 0;
	};

	const toggleIsOpen = (element) => {
		const newElement = openedElement
			? openedElement.index === element.index
				? null
				: element
			: element;

		setIsOpenedElement(newElement);
	};

	const onClick = (element) => {
		if (isExpandedList(element)) {
			return toggleIsOpen(element);
		}

		return props.onSelect(element);
	};

	const isOpen = (element) => {
		return openedElement && element.index === openedElement.index;
	};

	const renderItems = () => {
		return props.list.map((element) => {
			const open = isOpen(element);
			return (
				<>
					<ListItem
						onClick={onClick}
						element={element}
						isExpandedList={isExpandedList(element)}
						key={element.index}
						isChecked={props.isChecked(element)}
						isIndeterminate={props.isIndeterminate(element)}
						onSelect={props.onSelect}
						text={element.title}
						isOpen={open}
					/>
					{
						<Collapse in={open} timeout="auto" unmountOnExit>
							<List
								onSelect={props.onSelect}
								isChecked={props.isChecked}
								isIndeterminate={props.isIndeterminate}
								list={element.relatedItems}
								padding={padding + 1}
							/>
						</Collapse>
					}
				</>
			);
		});
	};

	return (
		<MuiList component="ul" disablePadding sx={{ ml: props.padding }}>
			{renderItems()}
		</MuiList>
	);
}
